// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5467bac6","977":"f66aee5a"}[chunkId] + ".chunk.js";
};